import React from "react";

const formatNow = () => {
  try {
    return new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "Now";
  }
};

const BellIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.73 21a2 2 0 01-3.46 0"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M5 12h14M13 6l6 6-6 6"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AdminNotificationToast = ({ title, body, onView, onClose }) => (
  <div className="vsara-admin-toast">
    <div className="vsara-admin-toast__icon" aria-hidden="true">
      <BellIcon />
    </div>

    <div className="vsara-admin-toast__content">
      <div className="vsara-admin-toast__header">
        <div className="vsara-admin-toast__meta">
          <span className="vsara-admin-toast__badge">Notification</span>
          <span className="vsara-admin-toast__dot" />
          <span className="vsara-admin-toast__time">{formatNow()}</span>
        </div>
        {onClose && (
          <button
            type="button"
            className="vsara-admin-toast__close"
            onClick={onClose}
            aria-label="Dismiss notification"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        )}
      </div>

      <h4 className="vsara-admin-toast__title">{title}</h4>
      <p className="vsara-admin-toast__body">{body}</p>

      {onView && (
        <button type="button" className="vsara-admin-toast__action" onClick={onView}>
          View details
          <ArrowIcon />
        </button>
      )}
    </div>
  </div>
);

export default AdminNotificationToast;
